import React, { useState } from "react";
import Heading from "../ui/Heading";
import { Col, Container, Image, Row } from "react-bootstrap";
import Round from "../Assets/img/diamond-shape/round-diamond.webp";
import Princess from "../Assets/img/diamond-shape/princess-diamond.webp";
import Cushion from "../Assets/img/diamond-shape/cushion-diamond.webp";
import Emerald from "../Assets/img/diamond-shape/emerald-diamond.webp";
import Oval from "../Assets/img/diamond-shape/oval-diamond.webp";
import Radiant from "../Assets/img/diamond-shape/radiant-diamond.webp";
import Asscher from "../Assets/img/diamond-shape/asscher-diamond.webp";
import Marquise from "../Assets/img/diamond-shape/marquise-diamond.webp";
import Heart from "../Assets/img/diamond-shape/heart-diamond.webp";
import Pear from "../Assets/img/diamond-shape/pear-diamond.webp";
import { Link, useHistory } from "react-router-dom/cjs/react-router-dom";
import { isMobile, isTablet } from "react-device-detect";
import Slider from "react-slick";
import { Je_welryspelling } from "../../../../Helpers/request";
import SlickLeft from "../../../../Assets/images/flawless-img/left-arrow.svg";
import SlickRight from "../../../../Assets/images/flawless-img/right-arrow.svg";


const dataOld = [
  {
    name: "Round",
    para: "Cut with the optimum light refraction and sparkle.",
    image: Round,
    url: "/diamonds/shape=Round",
  },
  {
    name: "Princess",
    para: "A contemporary cut, with optimal fire and brilliance.",
    image: Princess,
    url: "/diamonds/shape=Princess",
  },
  {
    name: "Cushion",
    para:
      "With soft corners, a beautiful alternative to a round or princess cut.",
    image: Cushion,
    url: "/diamonds/shape=Cushion",
  },
  {
    name: "Emerald",
    para:
      "This stylish cut creates rectangular facets with great stone's clarity.",
    image: Emerald,
    url: "/diamonds/shape=Emerald",
  },
  {
    name: "Oval",
    para: "Optimises carat, giving the illusion of a larger stone.",
    image: Oval,
    url: "/diamonds/shape=Oval",
  },
  {
    name: "Radiant",
    para: "The most brilliant of the rectangular cut diamonds.",
    image: Radiant,
    url: "/diamonds/shape=Radiant",
  },
  {
    name: "Asscher",
    para: "This unique shape is a square emerald, with linear facets.",
    image: Asscher,
    url: "/diamonds/shape=Asscher",
  },
  {
    name: "Marquise",
    para: "Elongate the finger of the wearer with a look of great grandeur.",
    image: Marquise,
    url: "/diamonds/shape=Marquise",
  },
  {
    name: "Heart",
    para: "A rare cut that is a true testament of your relationship.",
    image: Heart,
    url: "/diamonds/shape=Heart",
  },
  {
    name: "Pear",
    para: "Combining the brilliance and design of the Round and Marquise cuts.",
    image: Pear,
    url: "/diamonds/shape=Pear",
  },
];

const data = [
  {
    name: "Round",
    para: "Cut with the optimum light refraction and sparkle.",
    image: Round,
    url: "/diamonds/shape=Round",
    altText: "Round cut diamond with excellent sparkle"
  },
  {
    name: "Princess",
    para: "A contemporary cut, with optimal fire and brilliance.",
    image: Princess,
    url: "/diamonds/shape=Princess",
    altText: "Princess cut diamond with great brilliance"
  },
  {
    name: "Cushion",
    para: "With soft corners, a beautiful alternative to a round or princess cut.",
    image: Cushion,
    url: "/diamonds/shape=Cushion",
    altText: "Cushion cut diamond with soft corners"
  },
  {
    name: "Emerald",
    para: "This stylish cut creates rectangular facets with great stone's clarity.",
    image: Emerald,
    url: "/diamonds/shape=Emerald",
    altText: "Emerald cut diamond with rectangular facets"
  },
  {
    name: "Oval",
    para: "Optimises carat, giving the illusion of a larger stone.",
    image: Oval,
    url: "/diamonds/shape=Oval",
    altText: "Oval cut diamond with large carat appearance"
  },
  {
    name: "Radiant",
    para: "The most brilliant of the rectangular cut diamonds.",
    image: Radiant,
    url: "/diamonds/shape=Radiant",
    altText: "Radiant cut diamond with brilliant facets"
  },
  {
    name: "Asscher",
    para: "This unique shape is a square emerald, with linear facets.",
    image: Asscher,
    url: "/diamonds/shape=Asscher",
    altText: "Asscher cut diamond with square shape and linear facets"
  },
  {
    name: "Marquise",
    para: "Elongate the finger of the wearer with a look of great grandeur.",
    image: Marquise,
    url: "/diamonds/shape=Marquise",
    altText: "Marquise cut diamond with elongated shape"
  },
  {
    name: "Heart",
    para: "A rare cut that is a true testament of your relationship.",
    image: Heart,
    url: "/diamonds/shape=Heart",
    altText: "Heart shaped diamond, symbolizing love"
  },
  {
    name: "Pear",
    para: "Combining the brilliance and design of the Round and Marquise cuts.",
    image: Pear,
    url: "/diamonds/shape=Pear",
    altText: "Pear shaped diamond with a mix of round and marquise brilliance"
  },
];


const ShopByDiamondShape = () => {
  const history = useHistory();
  var settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 10,
    slidesToScroll: 0,
    prevArrow: <Image src={SlickLeft} alt="" />,
    nextArrow: <Image src={SlickRight} alt="" />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          initialSlide: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
    ],
  };
  const [diamondItem, setDiamondItem] = useState(data[0]);

  return (
    <>
      <section className="shop-diamond-by-shape section-space">
        <Container fluid className="showcase-container">
          <Heading>
            <h2>Shop Diamonds By Shape</h2>
            {/* <p>Explore  {Je_welryspelling}  Collections by Style and Make a Statement.</p> */}
          </Heading>
          <Row>
            <Col md={12}>
              <div className="inner-shop-diamond-shape">

                <div className="diamonds-collection">
          

                  <Slider {...settings}>
                    {data.map((item, i) => (
                      <div
                        className="diamond-item cursor-pointer"
                        key={i}
                        onClick={() => history.push(item.url)}
                        role="link" // Ensures that the div is treated as a link for accessibility
                        aria-label={`Shop ${item.name} Diamond`} // Adds descriptive ARIA label for screen readers
                      >
                        <Image
                          src={item.image}
                          alt={item.altText} // Use the dynamic altText from the data
                          loading="lazy" // Optionally, load images lazily for performance
                        />
                        <p className={`${item.name === item.name && "name"}`}>
                          {item.name}
                        </p>
                        {/* Optionally, show description if needed */}
                        {/* <p className={"desc"}>{item.para}</p> */}
                      </div>
                    ))}
                  </Slider>
                </div>

              </div>
            </Col>
          </Row>


        </Container>
      </section>
    </>
  );
};

export default ShopByDiamondShape;
